module.exports = __webpack_public_path__ + "static/media/so.cb906202.svg";